import axios from 'axios'

class InicioApiClient {


    async dashboard() {
        return axios.get('/inicio/dashboard')
    }

    async buscarPacientesAgendados(input) {
        return axios.get('/inicio/buscarPacientesAgendados', {params: input})
    }

}

export default new InicioApiClient()
